import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useMobileDrawerItemStyles } from 'components/UI/V2/MobileDrawer/Item/MobileDrawerItem.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface MobileDrawerItemProps extends React.ComponentProps<'div'> {
    label: string | React.ReactNode;
    icon?: IconProp;
}

export const MobileDrawerItem: React.FC<MobileDrawerItemProps> = ({ icon, label, ...props }) => {
    const classes = useMobileDrawerItemStyles();

    return (
        <div
            {...props}
            className={classes.root}
        >
            {icon && <FontAwesomeIcon icon={icon} />}

            {label}
        </div>
    );
};
